import { Button, Typography } from "components/atoms";
import "./error-modal.scss";

interface IProps {
  handleOnclose: any;
  message: any;
}

export const ErrorModal = ({ handleOnclose, message }: IProps) => {
  return (
    <>
      <div className="error-modal-header-wrapper">
        <Typography
          variant="h8Med"
          label="Error"
          styles="error-modal-header-text"
        />
      </div>
      <div className="error-modal-body-wrapper">
        <Typography
          variant="h8Book"
          label={message}
          styles="message-text-custom-style"
        />
        <div className="error-modal-button-wrapper">
          <Button
            icon={false}
            type="score"
            label="Okay"
            onClick={handleOnclose}
          />
        </div>
      </div>
    </>
  );
};
